import React, { useId } from 'react';

import Button from '~/components/core/Atomic/Buttons/Button';
import Text from '~/components/core/TextComponents/Text';
import cn from '~/Utils/cn';

interface OptionButtonProps {
  label: string;
  /** A line under the label. The button is named by the label alone, and described by this. */
  detail?: string;
  isPicked: boolean;
  onPick: () => void;
}

/** One choice while the question is open. Picking it selects it, and sends nothing. */
const OptionButton: React.FC<OptionButtonProps> = ({ label, detail, isPicked, onPick }) => {
  const detailId = useId();

  return (
    <Button
      variant="outlined"
      fullWidth
      role="radio"
      aria-checked={isPicked}
      aria-label={detail ? label : undefined}
      aria-describedby={detail ? detailId : undefined}
      onClick={onPick}
      className={cn(
        // h-auto: the theme pins buttons to 32px, which a label with a line under it overflows.
        'h-auto flex-col items-start gap-4 rounded-lg p-12 text-left normal-case',
        isPicked ? 'border-blue-600' : 'border-slate-300'
      )}
    >
      <Text variant={Text.VARIANTS.SM} weight={isPicked ? Text.WEIGHTS.SEMI_BOLD : Text.WEIGHTS.REGULAR}>
        {label}
      </Text>
      {detail ? (
        <span id={detailId}>
          <Text variant={Text.VARIANTS.SM} weight={Text.WEIGHTS.REGULAR} colorVariant={Text.COLOR_VARIANTS.SECONDARY}>
            {detail}
          </Text>
        </span>
      ) : null}
    </Button>
  );
};

export default OptionButton;
